import { render } from "./PlatformWeb.vue?vue&type=template&id=68007f40&scoped=true&ts=true"
import script from "./PlatformWeb.vue?vue&type=script&lang=ts"
export * from "./PlatformWeb.vue?vue&type=script&lang=ts"

import "./PlatformWeb.vue?vue&type=style&index=0&id=68007f40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68007f40"]])

export default __exports__